// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DummyTable from "../../../molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__PageNav from "../../../molecules/PageNav.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Search from "../../../molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../../molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Receipts(Props) {
  let viewReceipt = Props.viewReceipt;
  let maximizeReceipt = Props.maximizeReceipt;
  let org = Props.org;
  let id = Props.id;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match$1 = React.useState(function () {
    return 1;
  });
  const setPage = match$1[1];
  const page = match$1[0];
  const func = Buhta_cabinet__Kassa.ReceiptService.grid;
  const match$2 = Buhta_core__GrpcState.useGrid((function (param) {
    return Curry._2(func, param, id);
  }), undefined);
  const dispatch = match$2[1];
  const grid = match$2[0];
  React.useEffect((function () {
    Curry._3(dispatch, undefined, undefined, undefined);
  }), [id]);
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  const header = {
    hd: {
      name: "№ чека",
      style: ""
    },
    tl: {
      hd: {
        name: "Смена",
        style: ""
      },
      tl: {
        hd: {
          name: "ФП",
          style: ""
        },
        tl: {
          hd: {
            name: "Тип",
            style: ""
          },
          tl: {
            hd: {
              name: "Оплата",
              style: ""
            },
            tl: {
              hd: {
                name: "Сумма",
                style: "text-right"
              },
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const header$1 = viewReceipt ? header : Stdlib__List.append(header, {
      hd: {
        name: "Дата",
        style: "text-right"
      },
      tl: /* [] */ 0
    });
  const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */ 0 : Stdlib__List.mapi((function (i, receipt) {
      const operation_type = Buhta_cabinet__Kkm.OperationType.toStringRu(receipt.operation_type);
      const payment_type = Buhta_cabinet__Kkm.PaymentType.toReact(receipt.payment_type);
      const issue_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(receipt.issue_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
      const cells_0 = {
        body: String(receipt.serial_id),
        style: ""
      };
      const cells_1 = {
        hd: {
          body: "#" + String(receipt.shift_id),
          style: ""
        },
        tl: {
          hd: {
            body: receipt.ofd_receipt_id,
            style: ""
          },
          tl: {
            hd: {
              body: operation_type,
              style: ""
            },
            tl: {
              hd: {
                body: payment_type,
                style: ""
              },
              tl: {
                hd: {
                  body: MelNumeral.format({
                    NAME: "Str",
                    VAL: receipt.total_amount
                  }),
                  style: "justify-end"
                },
                tl: /* [] */ 0
              }
            }
          }
        }
      };
      const cells = {
        hd: cells_0,
        tl: cells_1
      };
      const cells$1 = viewReceipt ? cells : Stdlib__List.append(cells, {
          hd: {
            body: issue_time,
            style: "justify-end"
          },
          tl: /* [] */ 0
        });
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
        cells: cells$1,
        route: contextRoute({
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: id,
              _1: {
                TAG: /* Receipts */ 1,
                _0: {
                  TAG: /* View */ 0,
                  _0: receipt.id
                }
              }
            }
          }
        })
      }, Key);
    }), grid.VAL);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Search.make, {
        dispatch: dispatch,
        page: page,
        setPage: setPage,
        searchLength: 1,
        ignoreFirstTime: true
      }),
      typeof grid === "string" ? (
          grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        ) : (
          grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                  children: Stdlib__List.length(grid.VAL) > 0 ? JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                      header: header$1,
                      rows: rows,
                      styles: Cn.$plus(Cn.on("grid-cols-[repeat(7,_auto)] lg:grid-cols-7 first:sticky first:top-0", !viewReceipt), Cn.on("grid-cols-[repeat(6,_auto)]", viewReceipt))
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                          className: "w-10 h-10",
                          src: StaticAsset.src("/static/icons/piechart-40.svg")
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "mt-6 text-default-gray",
                          children: "Нет продаж"
                        })
                      ],
                      className: "flex flex-col items-center col-span-9 mt-84"
                    }),
                  className: "flex-1 overflow-auto"
                }),
                JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                  page: page,
                  setPage: setPage,
                  currentRecords: currentRecords
                })
              ]
            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        )
    ],
    className: Cn.$plus("flex flex-col w-full", Cn.on("hidden", maximizeReceipt || viewReceipt && deviceType === "mobile"))
  });
}

const make = Receipts;

export {
  make,
}
/* Buhta_cabinet__DummyTable Not a pure module */
